export const environment = {
	env: "awsDev",
	production: true,
	assetsPrefix: "",
	apiPrefix: "https://public-api.gbd.globaldb.dev.web1.wipo.int",
	wipoComponentsPath: "https://www3dev.wipo.int/webcomponents", // DEV components
	appUrl: "https://vienna-assistant.gbd.globaldb.dev.web1.wipo.int", // used in WIPO Navbar
};
